import { callBackend } from '@/api/callBackend'
import { ApiMethod } from 'common/src/api/types'
import { CancelToken } from 'axios'
import { APIResponseWrapper, CB_BASE_PREFIX } from '@/api/types'
import { ContentType } from 'common/src/commentThread/types'
import {
    GetCommentResponseTemplateRequest,
    GetCommentResponseTemplateResponse,
    SetCommentResponseTemplateRequest,
    SetCommentResponseTemplateResponse,
    ResetCommentResponseTemplateRequest,
    ResetCommentResponseTemplateResponse,
} from 'common/src/api/contentFrontendVsContentBackend/commentResponseTemplate'

const PREFIX = CB_BASE_PREFIX + '/contentCreatorAccount'

export const getCommentResponseTemplate = async (
    contentType: ContentType,
    cancelToken: CancelToken | null = null
): APIResponseWrapper<GetCommentResponseTemplateResponse> => {
    return await callBackend<
        GetCommentResponseTemplateRequest,
        GetCommentResponseTemplateResponse
    >(
        PREFIX + '/getCommentResponseTemplate',
        ApiMethod.GET,
        { contentType },
        cancelToken
    )
}

export const setCommentResponseTemplate = async (
    contentType: ContentType,
    template: string,
    cancelToken: CancelToken | null = null
): APIResponseWrapper<SetCommentResponseTemplateResponse> => {
    return await callBackend<
        SetCommentResponseTemplateRequest,
        SetCommentResponseTemplateResponse
    >(
        PREFIX + '/setCommentResponseTemplate',
        ApiMethod.POST,
        { contentType, template },
        cancelToken
    )
}

export const resetCommentResponseTemplate = async (
    contentType: ContentType,
    cancelToken: CancelToken | null = null
): APIResponseWrapper<ResetCommentResponseTemplateResponse> => {
    return await callBackend<
        ResetCommentResponseTemplateRequest,
        ResetCommentResponseTemplateResponse
    >(
        PREFIX + '/resetCommentResponseTemplate',
        ApiMethod.POST,
        { contentType },
        cancelToken
    )
}
